<template>
    <div class="buttons-cover">
        <div
            @click="changeSelectedPlan('monthly')"
            class="default-button"
            :class="{ selectedPlanButton: (value || 'annual') == 'monthly' }"
        >
            AYLIK
        </div>
        <div
            @click="changeSelectedPlan('annual')"
            class="default-button"
            :class="{ selectedPlanButton: (value || 'annual') == 'annual' }"
        >
            YILLIK <span class="free-months">(İndirimli)</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChangePlan",
    props: {
        value: String,
    },
    methods: {
        changeSelectedPlan(planType) {
            this.$emit("input", planType);
            this.$emit("plan-changed", planType);
        },
    },
};
</script>

<style lang="scss" scoped>
.buttons-cover {
    background: white;
    border-radius: 40px;
    display: flex;
    padding: 2px;
    font-size: 14px;
    height: 40px;
    cursor: pointer;
}

.selectedPlanButton {
    background-color: rgb(236 75 29) !important;
    color: white !important;
}

.default-button {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-border-radius: 40px;
    -moz-border-radius: 40px;
    border-radius: 40px;
}

.free-months {
    font-size: 9px;
}
</style>
